<template>
    <div id="tryoutgroup-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Tryout Group', to: { path: '/tryout-groups' } },
                { text: 'Tambah Tryout Group' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Tryout Group" : "Ubah Tryout Group" }}
        </h3>

        <v-card style="border">
            <v-card flat class="d-flex">
                <v-col cols="3" class="py-0">
                    <v-card flat>
                        <v-card-text class="pa-0 my-2">
                            <v-card
                                flat
                                class="border-bottom-divider rounded-tl pa-0"
                            >
                                <a href="javascript:;">
                                    <img
                                        :src="
                                            url
                                                ? url
                                                : require('@/assets/img/unavailable.png')
                                        "
                                        :key="keyimg"
                                    />
                                </a>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-0 my-2">
                            <v-btn
                                @click="$refs.uploader.click()"
                                block
                                class="pa-0 font-weight-bold dark--text"
                                color="white"
                            >
                                Upload *
                            </v-btn>
                            <input
                                type="file"
                                ref="uploader"
                                class="d-none"
                                accept="image/*"
                                @change="onFileChange"
                            />
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Ukuran gambar 400 x 500
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Maximum size is 300 KB
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="9">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Judul *
                                    </v-list-item-title>
                                    <v-text-field
                                        id="tryout_group_judul"
                                        placeholder="Judul Tryout"
                                        v-model="name"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Deskripsi *
                                    </v-list-item-title>
                                    <v-textarea
                                        id="tryout_group_deskripsi"
                                        placeholder="Deskripsi Tryout"
                                        v-model="description"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="px-0 pt-0 pb-4">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Kelas *
                                    </v-list-item-title>

                                    <v-select
                                        id="tryout_group_kelas"
                                        outlined
                                        placeholder="Pilih Kelas"
                                        v-model="grade"
                                        class="pa-0"
                                        :items="[
                                            { text: '1 (SD)', value: 1 },
                                            { text: '2 (SD)', value: 2 },
                                            { text: '3 (SD)', value: 3 },
                                            { text: '4 (SD)', value: 4 },
                                            { text: '5 (SD)', value: 5 },
                                            { text: '6 (SD)', value: 6 },
                                            { text: '7 (SMP)', value: 7 },
                                            { text: '8 (SMP)', value: 8 },
                                            { text: '9 (SMP)', value: 9 },
                                            { text: '10 (SMA)', value: 10 },
                                            { text: '11 (SMA)', value: 11 },
                                            { text: '12 (SMA)', value: 12 },
                                        ]"
                                    ></v-select>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="px-0 pt-0 pb-4">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Tipe *
                                    </v-list-item-title>

                                    <v-select
                                        id="tryout_group_tipe"
                                        outlined
                                        placeholder="Pilih Tipe"
                                        class="pa-0"
                                        v-model="type"
                                        :items="[
                                            { text: 'SBMPTN', value: 'SBMPTN' },
                                            {
                                                text: 'Ujian Nasional (UN)',
                                                value: 'UJIAN_AKHIR_NASIONAL',
                                            },
                                            {
                                                text: 'Ujian Akhir Sekolah (UAS)',
                                                value: 'UJIAN_AKHIR_SEKOLAH',
                                            },
                                            {
                                                text: 'Ujian Sekolah',
                                                value: 'UJIAN_SEKOLAH',
                                            },
                                        ]"
                                    ></v-select>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="px-0 pt-0 pb-4">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Kategori *
                                    </v-list-item-title>

                                    <v-select
                                        id="tryout_group_kategori"
                                        outlined
                                        placeholder="Pilih Kategori"
                                        v-model="variant"
                                        class="pa-0"
                                        :items="[
                                            {
                                                text: 'BERAGENDA',
                                                value: 'SCHEDULED',
                                            },
                                            {
                                                text: 'INSTANT',
                                                value: 'INSTANT_COMPLETE',
                                            },
                                            {
                                                text: 'TPM',
                                                value: 'TPM',
                                            },
                                        ]"
                                    ></v-select>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Pra-Syarat Tryout Serial
                                    </v-list-item-title>

                                    <app-tryoutgroupchooser
                                        :params="{
                                            grade: grade,
                                            status: 'PUBLISHED',
                                            type: type,
                                            variant: variant,
                                        }"
                                        v-on:dblClicked="addDependency($event)"
                                        v-on:clearGroup="removeDependency"
                                        :group="dependencyName"
                                    ></app-tryoutgroupchooser>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Opsi
                                    </v-list-item-title>
                                    <v-checkbox
                                        id="tryout_group_opsi_sticky"
                                        label="Sticky"
                                        class="pa-0 mr-0 ml-2 my-0"
                                        active-class="act-radio-btn"
                                        outlined
                                        v-model="isSticky"
                                    ></v-checkbox>
                                    <v-checkbox
                                        id="tryout_group_opsi_private"
                                        label="Private"
                                        class="pa-0 mr-0 ml-2 my-0"
                                        active-class="act-radio-btn"
                                        v-model="isPrivate"
                                        outlined
                                    ></v-checkbox>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Jenis Tryout </v-list-item-title
                                    ><v-radio-group row v-model="category">
                                        <v-radio
                                            id="live_class_type_free"
                                            label="FREE"
                                            value="FREE"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="live_class_type_premium"
                                            label="PREMIUM"
                                            value="PREMIUM"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                        <v-radio
                                            id="live_class_type_partner"
                                            label="KERJASAMA"
                                            value="PARTNER"
                                            class="jenjang-selection"
                                            active-class="act-radio-btn"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Kode Join (Opsional)
                                    </v-list-item-title>
                                    <v-text-field
                                        id="tryout_group_kode_join"
                                        v-model="joinCode"
                                        placeholder="Maksimal 10 karakter"
                                        :value="
                                            joinCode = joinCode.toUpperCase()
                                        "
                                        v-on:keypress="
                                            / /g.test(
                                                String.fromCharCode(
                                                    $event.keyCode,
                                                ),
                                            )
                                                ? $event.preventDefault()
                                                : true
                                        "
                                        v-on:keyup="
                                            joinCode = joinCode.replace(
                                                / /g,
                                                '',
                                            )
                                        "
                                        @change="
                                            joinCode = joinCode.replace(
                                                / /g,
                                                '',
                                            )
                                        "
                                        maxlength="10"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item class="pa-0">
                                <v-row>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Tanggal Pembahasan Umum *
                                                </v-list-item-title>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    discussionDate.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="tryout_group_tanggal_pembahasan_umum"
                                                                        v-model="
                                                                            discussionDate.value
                                                                        "
                                                                        append-icon="mdi-calendar"
                                                                        placeholder="Tanggal"
                                                                        readonly
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        outlined
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="
                                                                        discussionDate.value
                                                                    "
                                                                    no-title
                                                                    scrollable
                                                                    @change="
                                                                        discussionDate.option = false
                                                                    "
                                                                >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    discussionTime.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                :nudge-right="
                                                                    40
                                                                "
                                                                transition="scale-transition"
                                                                offset-y
                                                                max-width="290px"
                                                                min-width="290px"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="tryout_group_jam_pembahasan_umum"
                                                                        v-model="
                                                                            discussionTime.value
                                                                        "
                                                                        outlined
                                                                        placeholder="Jam"
                                                                        append-icon="mdi-clock-time-four-outline"
                                                                        readonly
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-time-picker
                                                                    v-if="
                                                                        discussionTime.option
                                                                    "
                                                                    v-model="
                                                                        discussionTime.value
                                                                    "
                                                                    @change="
                                                                        discussionTime.option = false
                                                                    "
                                                                    format="24hr"
                                                                ></v-time-picker>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Tanggal Pembahasan Siswa NF
                                                    *
                                                </v-list-item-title>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    discussionSpecialDate.option
                                                                "
                                                                :close-on-content-click="
                                                                    true
                                                                "
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="tryout_group_tanggal_siswa_nf"
                                                                        v-model="
                                                                            discussionSpecialDate.value
                                                                        "
                                                                        append-icon="mdi-calendar"
                                                                        placeholder="Tanggal"
                                                                        readonly
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        outlined
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="
                                                                        discussionSpecialDate.value
                                                                    "
                                                                    no-title
                                                                    scrollable
                                                                    @change="
                                                                        discussionSpecialDate.option = false
                                                                    "
                                                                >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    discussionSpecialTime.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                :nudge-right="
                                                                    40
                                                                "
                                                                transition="scale-transition"
                                                                offset-y
                                                                max-width="290px"
                                                                min-width="290px"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="tryout_group_jam_siswa_nf"
                                                                        v-model="
                                                                            discussionSpecialTime.value
                                                                        "
                                                                        outlined
                                                                        placeholder="Jam"
                                                                        append-icon="mdi-clock-time-four-outline"
                                                                        readonly
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-time-picker
                                                                    v-if="
                                                                        discussionSpecialTime.option
                                                                    "
                                                                    v-model="
                                                                        discussionSpecialTime.value
                                                                    "
                                                                    @change="
                                                                        discussionSpecialTime.option = false
                                                                    "
                                                                    format="24hr"
                                                                ></v-time-picker>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item class="pa-0">
                                <v-row>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Waktu Mulai
                                                </v-list-item-title>
                                                <v-text-field
                                                    outlined
                                                    readonly
                                                    disabled
                                                    :value="
                                                        variant ===
                                                            'SCHEDULED' ||
                                                        variant === 'TPM'
                                                            ? openedAt
                                                            : '-'
                                                    "
                                                ></v-text-field>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold pb-2"
                                                >
                                                    Waktu Selesai
                                                </v-list-item-title>
                                                <v-text-field
                                                    outlined
                                                    disabled
                                                    readonly
                                                    :value="
                                                        variant ===
                                                            'SCHEDULED' ||
                                                        variant === 'TPM'
                                                            ? closedAt
                                                            : '-'
                                                    "
                                                ></v-text-field>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pt-0 px-0 pb-6">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        User Group
                                    </v-list-item-title>
                                    <v-autocomplete
                                        :items="user_groups"
                                        item-text="user_group_name"
                                        item-value="id"
                                        class="pb-2"
                                        placeholder="-- Pilih user group --"
                                        outlined
                                        v-for="(usgr, i) in user_group"
                                        :key="i"
                                        v-model="user_group[i]"
                                    >
                                        <template v-slot:append-outer>
                                            <v-btn
                                                id="user-remove-scope-btn"
                                                dark
                                                x-large
                                                class="font-weight-bold dark--text py-3"
                                                depressed
                                                color="white"
                                                elevation="1"
                                                v-if="
                                                    i ===
                                                        user_group.length - 1 &&
                                                    user_group.length != 1
                                                "
                                                @click="
                                                    queryId
                                                        ? null
                                                        : user_group.splice(
                                                              i,
                                                              1,
                                                          )
                                                "
                                            >
                                                Hapus
                                            </v-btn>
                                        </template>
                                    </v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-text>
                        <v-container>
                            <v-btn
                                id="user-add-scope-btn"
                                @click="user_group.push('')"
                                block
                                depressed
                                class="font-weight-bold blew--text mb-5 mt-8"
                                color="#e8f5fa"
                            >
                                <v-icon style="font-size: 16px !important"
                                    >mdi-plus-circle</v-icon
                                >
                                Tambah User Group Baru
                            </v-btn>
                        </v-container>
                    </v-card>
                </v-col>
            </v-card>

            <v-card v-if="groupId" plain class="pa-4 mt-4">
                <h6 class="text-h6 font-weight-bold">Tryout</h6>
                <v-card
                    class="my-3 test_cursor"
                    v-for="(tryout, index) in tryouts"
                    v-bind:key="index"
                    @dblclick="editSubtest(index)"
                >
                    <v-list class="pa-2 text-subtitle-2">
                        <template>
                            <v-list-item two-line>
                                <v-list-item-content
                                    class="mx-2 my-0 align-self-start"
                                    style="max-width: 30%"
                                >
                                    <v-list-item-subtitle
                                        class="font-weight-bold"
                                    >
                                        Nama Tryout
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        style="
                                            text-overflow: unset;
                                            white-space: unset;
                                        "
                                    >
                                        {{ tryout.name }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-content
                                    class="mx-2 my-0 align-self-start"
                                    style="max-width: 20%"
                                >
                                    <v-list-item-subtitle
                                        class="font-weight-bold"
                                    >
                                        Tipe
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        {{ tryout.type }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-content
                                    class="mx-2 my-0 align-self-start"
                                    style="max-width: 10%"
                                >
                                    <v-list-item-subtitle
                                        class="font-weight-bold"
                                    >
                                        Kategori
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        {{ tryout.category }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-content
                                    class="mx-2 my-0 align-self-start"
                                >
                                    <v-list-item-subtitle
                                        class="font-weight-bold"
                                    >
                                        Mata Pelajaran
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        style="
                                            text-overflow: unset;
                                            white-space: unset;
                                        "
                                    >
                                        <span
                                            v-for="(
                                                subtest, index
                                            ) in tryout.subtests"
                                            v-bind:key="index"
                                        >
                                            {{ subtest.subject_name }},
                                        </span>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn
                                        plain
                                        class="pa-0"
                                        id="tryout_group_hapus_tryout"
                                        @click="
                                            dialogConfirm.function = tryout;
                                            dialogConfirm.title =
                                                'Apakah anda yakin akan melepas tryout ini?';
                                            dialogConfirm.open = true;
                                        "
                                    >
                                        <span
                                            class="red--text"
                                            :class="
                                                $vuetify.breakpoint.mdAndUp
                                                    ? 'font-weight-700'
                                                    : 'font-weight-600'
                                            "
                                            :style="
                                                $vuetify.breakpoint.smAndDown
                                                    ? 'font-size: 12px'
                                                    : ''
                                            "
                                            >Hapus</span
                                        >
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card>

                <app-tryoutchooser
                    v-on:selected="addTryoutIntoGroup($event)"
                    :isInstant="
                        $store.state.tryoutgroup.variant !== 'SCHEDULED' &&
                        $store.state.tryoutgroup.variant !== 'TPM'
                    "
                ></app-tryoutchooser>
            </v-card>
            <v-row class="pa-4 mt-4">
                <v-spacer></v-spacer>

                <v-btn
                    id="tryout_group_publish"
                    v-if="!isPublished"
                    color="backgroundYellow"
                    class="pull-right mx-2 darkYellow--text"
                    @click="publishTryoutGroup"
                >
                    Belum Publish
                </v-btn>
                <v-btn
                    id="tryout_group_unpublish"
                    v-else
                    color="backgroundGreen"
                    class="pull-right mx-2 darkGreen--text"
                    @click="unPublishTryoutGroup"
                >
                    Terpublish
                </v-btn>
                <v-btn
                    id="tryout_group_simpan"
                    color="primary"
                    @click="upload()"
                >
                    Simpan
                </v-btn>
            </v-row>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            removeTryoutFromGroup(dialogConfirm.function);
                            dialogConfirm.open = false;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AWS from "aws-sdk";
import Modal from "@/modules/global/components/plugins/Modal";
import Moment, { now } from "moment";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutChooser from "@/modules/tryout_group/components/TryoutChooser";
import TryoutGroupChooser from "@/modules/tryout_group/components/TryoutGroupChooser";
import TryoutService from "@/modules/tryout/services/tryout.js";
import { applyOssCredentials } from "@/modules/global/services/oss";
import axios from "axios";
import uniqid from "uniqid";

export default {
    name: "tryoutgroup-form",

    components: {
        "app-modal": Modal,
        "app-spinner": Spinner,
        "app-tryoutchooser": TryoutChooser,
        "app-tryoutgroupchooser": TryoutGroupChooser,
    },

    data: function () {
        return {
            discussionDate: {
                value: null,
                option: false,
            },
            discussionTime: {
                value: null,
                option: false,
            },
            discussionSpecialDate: {
                value: null,
                option: false,
            },
            discussionSpecialTime: {
                value: null,
                option: false,
            },
            queryId: null,
            normalStartDate: null,
            normalStartTime: null,
            normalEndDate: null,
            normalEndTime: null,
            isLoading: false,
            showModal: false,
            dependencyName: "",
            errors: [],
            step: 1,
            groupC: null,
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            user_groups: [],
            url: null,
            imageFile: null,
            banner_url: null,
            keyimg: 0,
        };
    },

    computed: {
        isPublished: function () {
            return this.$store.state.tryoutgroup.status == "PUBLISHED";
        },

        groupId: function () {
            return this.$store.state.tryoutgroup.id;
        },

        name: {
            get: function () {
                return this.$store.state.tryoutgroup.name;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_name", value);
            },
        },

        description: {
            get: function () {
                return this.$store.state.tryoutgroup.description;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_description", value);
            },
        },

        type: {
            get: function () {
                return this.$store.state.tryoutgroup.type;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_type", value);
            },
        },

        variant: {
            get: function () {
                return this.$store.state.tryoutgroup.variant;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_variant", value);
            },
        },

        grade: {
            get: function () {
                return this.$store.state.tryoutgroup.grade;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_grade", value);
            },
        },

        category: {
            get: function () {
                return this.$store.state.tryoutgroup.category;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_category", value);
            },
        },

        joinCode: {
            get: function () {
                return this.$store.state.tryoutgroup.joinCode;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_join_code", value);
            },
        },

        user_group: {
            get: function () {
                // alert(JSON.stringify(this.$store.state.tryoutgroup.user_groups))
                return this.$store.state.tryoutgroup.user_groups;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_user_groups", value);
            },
        },

        image: {
            get: function () {
                return this.$store.state.tryoutgroup.image;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_image", value);
            },
        },

        isPrivate: {
            get: function () {
                return this.$store.state.tryoutgroup.isPrivate;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_is_private", value);
            },
        },

        isSticky: {
            get: function () {
                return this.$store.state.tryoutgroup.isSticky;
            },

            set: function (value) {
                this.$store.commit("tryout_group_set_is_sticky", value);
            },
        },

        tryouts: function () {
            return this.$store.state.tryoutgroup.tryouts;
        },

        openedAt: function () {
            var time = this.$store.getters.openedAt;
            return time > 0 ? Moment(time).format("DD/MM/YYYY HH:mm") : "-";
        },

        closedAt: function () {
            var time = this.$store.getters.closedAt;
            return time > 0 ? Moment(time).format("DD/MM/YYYY HH:mm") : "-";
        },

        normalStartRules() {
            var a = Moment(this.openedAt, "DD/MM/YYYY HH:mm");
            var b = Moment(this.closedAt, "DD/MM/YYYY HH:mm");
            var a2 = Moment(
                this.normalStartDate + " " + this.normalStartTime,
                "DD/MM/YYYY HH:mm",
            );
            const rule = a2.diff(a);
            const rule2 = b.diff(a2);
            if (a.diff(a2) <= 0 && b.diff(a2) >= 0) return " ";
            else
                return (
                    "Waktu harus berada diantara " +
                    this.openedAt +
                    " dan " +
                    this.closedAt
                );
        },

        normalEndRules() {
            var a = Moment(this.openedAt, "DD/MM/YYYY HH:mm");
            var a2 = Moment(
                this.normalEndDate + " " + this.normalEndTime,
                "DD/MM/YYYY HH:mm",
            );
            var b = Moment(this.closedAt, "DD/MM/YYYY HH:mm");
            if (a.diff(a2) <= 0 && b.diff(a2) >= 0) return " ";
            else
                return (
                    "Waktu harus berada diantara " +
                    this.openedAt +
                    " dan " +
                    this.closedAt
                );
        },
    },

    methods: {
        addTryoutIntoGroup: function (tryout) {
            this.isLoading = true;
            var context = this;
            if (!this.groupId) {
                this.$store.commit("showAlert", {
                    message: `Data belum disimpan!`,
                    submessage: `Silahkan selesaikan penambahan tryout terlebih dahulu!`,
                    type: "error",
                });
            }

            TryoutService.addTryoutIntoGroup(
                tryout.id,
                this.groupId,
                function (result) {
                    if (result.success) {
                        context.$store.commit(
                            "tryout_group_add_tryout",
                            result.data,
                        );
                    }

                    context.isLoading = false;
                },
            );
        },

        removeTryoutFromGroup: function (tryout) {
            var context = this;
            this.isLoading = true;

            TryoutService.removeTryoutFromGroup(
                tryout.id,
                this.groupId,
                function (result) {
                    if (result.success) {
                        context.$store.commit(
                            "tryout_group_remove_tryout",
                            result.data,
                        );
                    }

                    context.isLoading = false;
                },
            );
        },

        saveTryoutGroup: function () {
            if (!this.validateForm()) {
                return;
            }

            this.isLoading = true;
            var context = this;
            var timestamp =
                this.discussionDate.value + " " + this.discussionTime.value;
            var discussionOpenedAt = Moment(
                timestamp,
                "YYYY-MM-DD HH:mm",
            ).valueOf();

            var timestampSpecial =
                this.discussionSpecialDate.value +
                " " +
                this.discussionSpecialTime.value;
            var discussionSpecialAt = Moment(
                timestampSpecial,
                "DD/MM/YYYY HH:mm",
            ).valueOf();

            var timestampNormalStart =
                this.normalStartDate + " " + this.normalStartTime;
            var timestampNormalEnd =
                this.normalEndDate + " " + this.normalEndTime;
            var openedNormal = Moment(
                timestampNormalStart,
                "DD/MM/YYYY HH:mm",
            ).valueOf();
            var closedNormal = Moment(
                timestampNormalEnd,
                "DD/MM/YYYY HH:mm",
            ).valueOf();

            var tryoutGroup = {
                name: this.$store.state.tryoutgroup.name,
                description: this.$store.state.tryoutgroup.description,
                type: this.$store.state.tryoutgroup.type,
                variant: this.$store.state.tryoutgroup.variant,
                discussion_opened_at: discussionOpenedAt,
                discussion_special_at: discussionSpecialAt,
                opened_normal: openedNormal,
                closed_normal: closedNormal,
                banner_url: this.banner_url,
                grade: this.$store.state.tryoutgroup.grade,
                join_code: this.$store.state.tryoutgroup.joinCode,
                is_sticky: this.$store.state.tryoutgroup.isSticky,
                is_private: this.$store.state.tryoutgroup.isPrivate,
                dependency_id: this.$store.state.tryoutgroup.dependency_id,
                user_group: this.user_group,
                category: this.$store.state.tryoutgroup.category,
            };

            var groupId = this.$store.state.tryoutgroup.id;
            if (groupId) {
                TryoutService.editTryoutGroup(
                    groupId,
                    tryoutGroup,
                    function (result) {
                        if (result.success) {
                            context.$store.commit("showAlert", {
                                message: `Tryout Group berhasil diubah!`,
                                type: "success",
                            });
                            context.$router.push({
                                path: "/tryout-groups",
                            });
                        } else {
                            context.$store.commit("showAlert", {
                                message: `Terjadi Kesalahan, gagal menyimpan!`,
                                type: "error",
                            });
                        }

                        context.isLoading = false;
                    },
                );
            } else {
                TryoutService.createTryoutGroup(tryoutGroup, function (result) {
                    if (result.success) {
                        context.$store.commit("showAlert", {
                            message: `Tryout Group berhasil dibuat!`,
                            type: "success",
                        });
                        context.$router.push({
                            path: "/tryout-groups",
                        });
                        context.$store.commit(
                            "tryout_group_set_id",
                            result.data.id,
                        );
                    }

                    context.isLoading = false;
                });
            }
        },

        publishTryoutGroup: function () {
            if (this.checkIfTryoutGroupIsOnGoing()) {
                this.$store.commit("showAlert", {
                    message: `Tidak dapat mem-publish tryout group yang sudah lewat waktu mulainya!`,
                    type: "error",
                });
                return;
            }

            if (this.checkIfTryoutGroupIsExpired()) {
                this.$store.commit("showAlert", {
                    message: `Tidak dapat mem-publish tryout group yang sudah lewat waktu berakhirnya!`,
                    type: "error",
                });
                return;
            }

            var tryoutCount = this.$store.state.tryoutgroup.tryouts.length;
            if (tryoutCount == 0) {
                this.$store.commit("showAlert", {
                    message: `Tidak dapat publish tryout group kosong!`,
                    type: "error",
                });
                return;
            }

            var confirmed = window.confirm(
                "Apakah anda yakin akan PUBLISH group ini?",
            );

            if (confirmed) {
                this.isLoading = true;
                var context = this;
                TryoutService.publishTryoutGroup(
                    this.groupId,
                    function (result) {
                        if (result.success) {
                            context.$store.commit(
                                "tryout_group_set_status",
                                result.data.status,
                            );
                        }

                        context.isLoading = false;
                    },
                );
            }
        },

        unPublishTryoutGroup: function () {
            if (this.checkIfTryoutGroupIsOnGoing()) {
                window.alert(
                    "Tidak dapat mengubah status group tryout yang sedang berlangsung",
                );
                return;
            }

            var confirmed = window.confirm(
                "Apakah anda yakin akan mengembalikan group ini ke DRAFT?",
            );

            if (confirmed) {
                this.isLoading = true;
                var context = this;
                TryoutService.unPublishTryoutGroup(
                    this.groupId,
                    function (result) {
                        if (result.success) {
                            context.$store.commit(
                                "tryout_group_set_status",
                                result.data.status,
                            );
                        }

                        context.isLoading = false;
                    },
                );
            }
        },

        checkIfTryoutGroupIsOnGoing: function () {
            if (this.variant !== "SCHEDULED") return false;

            var startTime = this.$store.getters.openedAt;
            var endTime = this.$store.getters.closedAt;
            var nowTime = new Date().valueOf();

            return nowTime > startTime && nowTime < endTime;
        },

        checkIfTryoutGroupIsExpired: function () {
            if (this.variant !== "SCHEDULED") return false;

            var endTime = this.$store.getters.closedAt;
            var nowTime = new Date().valueOf();

            return nowTime > endTime;
        },

        validateForm: function () {
            var error = false;
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            this.name = this.name.trim();

            if (this.name == "" || this.name == null || this.name == " ") {
                this.$store.commit("showAlert", {
                    message: `Judul wajib diisi !`,
                    type: "error",
                });
                error = true;
            }
            this.description = this.description.trim();

            if (
                this.description == "" ||
                this.description == null ||
                this.description == " "
            ) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi wajib diisi !`,
                    type: "error",
                });
                error = true;
            }

            if (this.discussionDate.value == null) {
                this.$store.commit("showAlert", {
                    message: `Tanggal pembahasan untuk umum wajib diisi !`,
                    type: "error",
                });
                error = true;
            }

            if (this.discussionTime.value == null) {
                this.$store.commit("showAlert", {
                    message: `Waktu pembahasan untuk umum wajib diisi !`,
                    type: "error",
                });
                error = true;
            }

            if (this.discussionSpecialDate.value == null) {
                this.$store.commit("showAlert", {
                    message: `Tanggal pembahasan untuk siswa NF wajib diisi !`,
                    type: "error",
                });
                error = true;
            }

            if (this.discussionSpecialTime.value == null) {
                this.$store.commit("showAlert", {
                    message: `Waktu pembahasan untuk siswa NF wajib diisi !`,
                    type: "error",
                });
                error = true;
            }

            if (
                this.variant == "TPM" &&
                this.openedAt != "-" &&
                this.normalStartDate == null
            ) {
                this.$store.commit("showAlert", {
                    message: `Tanggal Normal Mulai wajib diisi !`,
                    type: "error",
                });
                error = true;
            }

            if (
                this.variant == "TPM" &&
                this.openedAt != "-" &&
                this.normalStartTime == null
            ) {
                this.$store.commit("showAlert", {
                    message: `Waktu Normal Berakhir wajib diisi !`,
                    type: "error",
                });
                error = true;
            }

            if (
                this.variant == "TPM" &&
                this.openedAt != "-" &&
                this.normalEndDate == null
            ) {
                this.$store.commit("showAlert", {
                    message: `Tanggal Normal Mulai wajib diisi !`,
                    type: "error",
                });
                error = true;
            }

            if (
                this.variant == "TPM" &&
                this.openedAt != "-" &&
                this.normalEndTime == null
            ) {
                this.$store.commit("showAlert", {
                    message: `Waktu Normal Berakhir wajib diisi !`,
                    type: "error",
                });
                error = true;
            }

            if (
                this.variant == "TPM" &&
                this.openedAt != "-" &&
                this.normalStartRules != " "
            ) {
                this.$store.commit("showAlert", {
                    message: this.normalStartRules,
                    type: "error",
                });
                error = true;
            }

            if (
                this.variant == "TPM" &&
                this.openedAt != "-" &&
                this.normalEndRules != " "
            ) {
                this.$store.commit("showAlert", {
                    message: this.normalEndRules,
                    type: "error",
                });
                error = true;
            }

            return !error;
        },

        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 300000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 300 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.keyimg++;
            this.url = URL.createObjectURL(file);
        },

        async upload(e) {
            this.isLoading = true;
            if (this.validateForm()) {
                var file = this.imageFile;

                if (this.banner_url && !file) {
                    this.image = this.banner_url;
                    this.saveTryoutGroup();
                } else {
                    if (!file) return;
                    if (file.type.indexOf("image") == -1) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi kesalahan pada upload!`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT; // 'oss-ap-southeast-5.aliyuncs.com'
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var fileExt = file.name.substr(-4);
                    var filename = uniqid() + fileExt;
                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET,
                        Key: "tryout_group/" + file.name,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan pada upload!`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.banner_url = data.Location;
                            context.saveTryoutGroup();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        addDependency: function (group) {
            this.dependencyName = group.name;
            this.groupC = group.name;
            this.$store.commit("tryout_group_set_dependency_id", group.id);
        },

        removeDependency: function () {
            this.showModal = false;
            this.dependencyName = "";
            this.$store.commit("tryout_group_set_dependency_id", null);
        },

        reload: function () {
            var grade = this.grade;
        },

        getUserGroupData() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "/payment/list/user_group?page=1&per_page=1000";

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.user_groups = response.data.user_groups;
                }
            });
        },
    },

    async mounted() {
        var context = this;
        var tryoutGroup = {};

        if (this.$route.query.id) {
            await TryoutService.getTryoutGroup(
                this.$route.query.id,
                function (result) {
                    if (result.success) {
                        tryoutGroup = result.data;
                        context.$store.commit("tryout_group_init", tryoutGroup);

                        var timestampMilis = tryoutGroup.discussion_opened_at;
                        context.banner_url = tryoutGroup.banner_url;
                        context.url = tryoutGroup.banner_url;
                        context.discussionDate.value =
                            Moment(timestampMilis).format("YYYY-MM-DD");
                        context.discussionTime.value =
                            Moment(timestampMilis).format("HH:mm");

                        var timestampMilisSpecial =
                            tryoutGroup.discussion_special_at;
                        context.discussionSpecialDate.value = Moment(
                            timestampMilisSpecial,
                        ).format("YYYY-MM-DD");
                        context.discussionSpecialTime.value = Moment(
                            timestampMilisSpecial,
                        ).format("HH:mm");

                        var timestampMilisOpenNormal =
                            tryoutGroup.opened_normal;
                        context.normalStartDate = Moment(
                            timestampMilisOpenNormal,
                        ).format("DD/MM/YYYY");
                        context.normalStartTime = Moment(
                            timestampMilisOpenNormal,
                        ).format("HH:mm");

                        var timestampMilisCloseNormal =
                            tryoutGroup.closed_normal;
                        context.normalEndDate = Moment(
                            timestampMilisCloseNormal,
                        ).format("DD/MM/YYYY");
                        context.normalEndTime = Moment(
                            timestampMilisCloseNormal,
                        ).format("HH:mm");

                        if (tryoutGroup.dependency_id) {
                            var groupId = tryoutGroup.dependency_id;
                            TryoutService.getTryoutGroup(
                                groupId,
                                function (response) {
                                    context.dependencyName = response.data.name;
                                },
                            );
                        }

                        var userGroup = [];
                        if (tryoutGroup.user_groups.length > 0) {
                            for (
                                var i = 0;
                                i < tryoutGroup.user_groups.length;
                                i++
                            ) {
                                userGroup.push(tryoutGroup.user_groups[i].id);
                            }
                        }
                        context.user_group = userGroup;
                    }
                },
            );
        }

        this.getUserGroupData();
    },
};
</script>



// WEBPACK FOOTER //
// Form.vue?72f1ed9f